import { render, staticRenderFns } from "./IdleAlert.vue?vue&type=template&id=80745ee0&scoped=true&"
import script from "./IdleAlert.vue?vue&type=script&lang=js&"
export * from "./IdleAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80745ee0",
  null
  
)

export default component.exports